<template>
    <component :is="loadComponent"
        v-bind="{...$props, ...{ partnerId }}"
    />
</template>

<script>
import {
    mapGetters,
    mapActions,
} from 'vuex';

import localStoreTypes from '@webapp/store/types.js';
import localEpicTypes from '@webapp/epics/types.js';

// Helpers
import {
    removeDomElementBySelector,
} from '@webapp/helpers/generic.js';

export default {
    name: 'home',
    computed: {
        ...mapGetters(['isPartnerApp', 'partnerAppData']),

        partnerId() {
            return this.partnerAppData ? this.partnerAppData.id : '';
        },

        loadComponent() {
            const componentName = this.isPartnerApp ? 'partner/partner' : 'home/overview';

            return () => import(`../${componentName}.vue`);
        },
    },
    async mounted() {
        await this.loadMarkets();

        this.$nextTick(() => {
            this.showAppLoader({
                isVisible: false,
            });
        });

        // Geetest clean-up
        removeDomElementBySelector('.geetest_panel');
    },
    methods: {
        ...mapActions({
            showAppLoader: localStoreTypes.SET_APP_LOADER,
            loadMarkets: localEpicTypes.GET_AVAILABLE_MARKETS,
        }),
    },
};
</script>